import { writable } from "svelte/store";
import { MapillaryImageViewerManager } from "./viewer/MapillaryImageViewerManager";
import { MapillaryMapLayer } from "./map/MapillaryMapLayer";
export class MapillaryManager {
    constructor(options) {
        this.visible = writable(false);
        this.imageIdStore = writable(undefined);
        this.imageIdHoverStore = writable(undefined);
        this.viewerVisible = writable(false);
        this.options = options;
        this.viewManager = new MapillaryImageViewerManager(this, {
            apiKey: this.options.apiKey
        });
        this.mapLayer = new MapillaryMapLayer(this, this.options.apiKey);
        this.visible.subscribe(v => {
            if (v) {
                this.viewManager.show();
            }
            else {
                this.viewManager.hide();
            }
            this.mapLayer.onVisibleChanged(v);
        });
        this.imageIdStore.subscribe(iId => {
            this.viewManager.setImageId(iId);
        });
    }
    addToMap(map) {
        this.mapLayer.addToMap(map);
    }
    onMapClick(e) {
        return this.mapLayer.onMapClick(e);
    }
    onMapMouseOver(e) {
        return this.mapLayer.onMapMouseOver(e);
    }
    onMouseOverImage(imageFeature) {
        if (typeof imageFeature === "undefined") {
            this.imageIdHoverStore.set(undefined);
            return;
        }
        this.imageIdHoverStore.set(imageFeature.properties["id"].toString());
    }
    onMouseClickImage(imageFeature) {
        this.imageIdStore.set(imageFeature.properties["id"].toString());
    }
    getImageIdStore() {
        return this.imageIdStore;
    }
    getImageIdHoverStore() {
        return this.imageIdHoverStore;
    }
    getVisibleStore() {
        return this.visible;
    }
    getViewerManager() {
        return this.viewManager;
    }
}
